module.exports = __webpack_public_path__ + "static/media/next-icon-napkin-o.3fb911f8.svg";